import makeStyles from "@mui/styles/makeStyles";

export const useStyles = makeStyles((theme) => ({
  label: {
    fontWeight: theme.typography.fontWeightSemiBold,
    color: theme.palette.tertiary.main,
  },
}));
